import React from 'react';
import urlToMyPdf from './resume.pdf'
import './index.scss';

import stupidFace from './stupidFace.jpg';


function Main() {
  return (

    <main className="page-about">
      <section className="beautiful-face">
        <img alt="Lana's face" src={stupidFace}/>
      </section>

      <section className="bio">
        <div className="caption">Lana is an illustrator, concept artist and a 2D Harmony rigger. Clients include Netflix, FX. Previous shows include Red FIsh Blue Fish, Dogs in Space, Oddballs, Little Demon and more.


        </div>

        <table>
          <tbody>
            <tr>
              
              <td>Work experience</td>
              <td>
                <span className="bold"><strong>Atomic Cartoons</strong></span><br/>
                2D Harmony Builds Artist and Prop Designer
              </td>
              <td>Oct 2020 - Nov 2024</td>
            </tr>

            <tr>
              <td>Education</td>
              <td>
              <span className="bold"><strong>Capilano University</strong></span><br/>
              2D Animation and Visual Development Diploma</td>
              <td>2018 - 2020</td>
            </tr>

            <tr>
              <td></td>
              <td>
              <span className="bold"><strong>St.Petersburg Polytechnic University</strong></span><br/>
              Bsc Mathematical Software and Information Systems Administration
              </td>
              <td>2012 - 2016</td>
            </tr>

            <tr>
                <td>Software Proficiencies</td>
                <td>
                <ul className="bold">
                    <li>Toon Boom Harmony </li>
                    
                    <li>Adobe Photoshop </li>
                    <li>Blender </li>
                    <li>Unity, Godot, UE5 </li>
                    
                    
                </ul>
                </td>
            </tr>

          </tbody>
        </table>

         <a target="_blank" className="resume-class" href={urlToMyPdf}>   View resume</a>
      </section>
             </main>
  );
}

export default Main;
